import { Field, Form as FormikForm, Formik } from 'formik';

import Form from 'react-bootstrap/Form';

import React, { useEffect, useState } from 'react';
import { Button, Col, Modal, OverlayTrigger, Row, Spinner, Table, Tooltip } from 'react-bootstrap';
import { FaRegEdit } from 'react-icons/fa';
import { RiDeleteBin6Line } from 'react-icons/ri';
import Pagination from 'react-js-pagination';
import { shallowEqual, useSelector } from 'react-redux';
import Swal from 'sweetalert2';
import * as Yup from 'yup';
import API from '../../../../shared/AdminAxios';
import { showErrorMessage } from '../../../../shared/handle_error';
import { getHeightWidth } from '../../../../shared/helper';
import closeIcon from '../../../../assets/images/close.svg';
import './productImage.css';

// Debounce function outside component to prevent recreation
const debounce = (func, delay = 300) => {
  let timer;
  return function(...args) {
    clearTimeout(timer);
    timer = setTimeout(() => func.apply(this, args), delay);
  };
};
const renderTooltip = (props) => (
	<Tooltip id="button-tooltip" {...props}>
		Delete Product Image
	</Tooltip>
);

export default function ProductImage() {
	const [show, setShow] = useState(false);
	const [file, setFile] = useState([]);
	const [isValid, setValid] = useState(false);
	const [loading, setLoading] = useState(false);
	const [count, setCount] = useState('');
	const [productImageId, setProductImageId] = useState(0);
	const [details, setDetails] = useState('');
	const [productImage, setProductImage] = useState([]);
	const [callPageNo, setCallPageNo] = useState(1);
	const [currentPage, setCurrentPage] = useState(0);
	const [modalShow, setModalShow] = React.useState(false);
	const [activePage, setActivePage] = useState(1);
	const [search, setSearch] = useState([]);

	const [img, setImg] = useState('');
	const [flag, setFlag] = useState(false);
	const [inputValue, setInputValue] = useState('');
	const [searchTerm, setSearchTerm] = useState('');
	const [selectPage, setSelectPage] = useState([{ value: 'HOME', label: 'Home' }]);

	// Debounced search function
	const debouncedSearch = React.useCallback(
		debounce((searchValue) => {
			setSearch(searchValue);
		}, 500),
		[]
	);

	// Handle input change
	const handleInputChange = (e) => {
		const { value } = e.target;
		setInputValue(value);
		debouncedSearch(value);
	};

	// Clear search
	const clearSearch = () => {
		setInputValue('');
		setSearch('');
	};

	const mapStateToProps = (state) => ({
		adminProductType: state.auth?.adminProductType,
	});
	const { adminProductType } = useSelector(mapStateToProps, shallowEqual);
	const [productType, setProductType] = useState(adminProductType);

	useEffect(() => {
		setProductType(adminProductType);
	}, [adminProductType]);

	const handleClose = () => {
		setShow(false);
		setProductImageId(0);
	};
	const handleShow = () => setShow(true);
	const initialValues = {
		file: [],
	};

	function MyVerticallyCenteredModal(props) {
		return (
			<Modal {...props} size="sm" aria-labelledby="contained-modal-title-vcenter" centered>
				<Modal.Header closeButton></Modal.Header>
				<Modal.Body>
					<img style={{ width: '100%' }} src={img} alt="" />
				</Modal.Body>
			</Modal>
		);
	}

	const productImageSchema = Yup.object().shape({
		file: Yup.string()
			.required('Please select the Image')
			.test('image', 'Only files with the following extensions are allowed: png ', (e) =>
				['image/png'].includes(JSON.parse(e).type)
			)
			.test('fileSize', 'Maximum 5 mb size file is supported', (e) => Number(JSON.parse(e).size) < 5 * (1024 * 1024)),
	});

	// const iconStyle = {
	//   fontSize: "50px",
	//   paddingRight: "30px",
	//   cursor: "pointer",
	//   width: "50px",
	// };

	const fileChangedHandler = (event, setFieldTouched, setFieldValue, setErrors) => {
		let imagefileslength = event.target.files.length;
		const SUPPORTED_FORMATS = ['image/png'];
		let fileData = '';
		let image_arr = [];
		for (let i = 0; i < imagefileslength; i++) {
			// console.log("event.target.files[0].type,>>", event.target.files[i].type);
			fileData = JSON.stringify({
				type: event.target.files[i].type,
				size: event.target.files[i].size,
			});

			setFieldValue('file', fileData);
			if (!event.target.files[i]) {
				// setValid(true);
				setFile([]);
				setErrors({
					file: 'Please select the Image',
				});
			}
			if (event.target.files[i] && SUPPORTED_FORMATS.includes(event.target.files[i].type)) {
				// setValid(true);
				image_arr.push(event.target.files[i]);

				// console.log(" image_arr>>>>>>>>>>>>>>>>>>>>>", image_arr);

				// setFile(event.target.files[i]);
			}
		}
	};

	const handleSubmit = async (values, actions) => {
		const formData = new FormData();
		let invalid = [];
		let old_file = [...file];

		for (let i = 0; i < file.length; i++) {
			let current_file = old_file[i];
			await getHeightWidth(file[i]).then((dimension) => {
				const { height, width } = dimension;

				if (height != 200 && width != 200) {
					invalid.push(current_file);
					actions.setErrors({
						file: `${invalid.length} file does not match height and width validations.`,
					});
					setValid(false);
					setFlag(true);
					actions.setSubmitting(false);
					return false;
				}
			});
		}

		if (invalid.length === 0) {
			for (let j = 0; j < file.length; j++) {
				formData.append('file', file[j]);
			}
			API({
				method: 'POST',
				url: `/api/adm/product-images`,
				data: formData,
			})
				.then((res) => {
					Swal.fire({
						icon: 'success',
						text: 'Product Image Added Successfully',
					});
					setShow(false);
					getProductImage();
				})

				.catch((err) => {
					setShow(false);
					Swal.fire({
						icon: 'error',
						text: 'Product Image not added successfully',
					});
				});
		} else {
		}
	};

	const getProductImage = () => {
		setLoading(true);
		API({
			method: 'GET',
			url: `/api/adm/product-images?search_text=${search}`,
		})
			.then((res) => {
				// console.log("res:", res);
				setCount(res.data.count_product_images);

				if (callPageNo === 1) {
					setProductImage(res.data.data);
				} else {
					setProductImage((prev) => [...prev, ...res.data.data]);
				}

				setCurrentPage(callPageNo);

				if (Number(res.data?.count_product_images ?? 0) > 20) {
					document.addEventListener('scroll', onScroll);
				}
				setLoading(false);
			})
			.catch((err) => {
				console.log('err:', err);
				setLoading(false);
				showErrorMessage(err);
			});
	};

	const handleDelete = (id, e) => {
		e.preventDefault();
		const swalWithBootstrapButtons = Swal.mixin({
			customClass: {
				confirmButton: 'btn btn-success mx-3',
				cancelButton: 'btn btn-danger mx-3',
			},
			buttonsStyling: false,
		});
		swalWithBootstrapButtons
			.fire({
				title: 'Are you sure?',
				text: "You won't be able to revert this!",
				icon: 'warning',
				showCancelButton: true,
				confirmButtonText: 'Delete',
				cancelButtonText: 'Cancel',
				reverseButtons: true,
			})
			.then((result) => {
				if (result.isConfirmed) {
					API({
						method: 'PUT',
						url: `/api/adm/delete-product-image/${id}`,
					})
						.then((res) => {
							Swal.fire('Deleted!', 'Your product image has been deleted.', 'success');
							getProductImage();
							setShow(false);
						})
						.catch((err) => {
							if (err.data.status === 3) {
							}
						});
				}
			});
	};

	const onScroll = () => {
		const e = document.getElementsByTagName('body')[0];
		if (e.getBoundingClientRect().bottom <= window.innerHeight + 16) {
			document.removeEventListener('scroll', onScroll);
			setCallPageNo(callPageNo + 1);
		}
	};
	const handlePageChange = (pageNumber) => {
		setActivePage(pageNumber);
		getProductImage(pageNumber > 0 ? pageNumber : 1);
	};

	useEffect(() => {
		getProductImage();
	}, [search]);

	const newInitialValues = Object.assign(initialValues, {
		file: details.file ? details.file : '',
	});
	return (
		<div className="content-wrapper p-1">
			<section>
				<div className="row">
					<div className="col-md-12">
						<h3 className="mb-3">
							Manage Product Image &nbsp;
							<span>(Total : {count})</span>
						</h3>
					</div>

					<div className="col-md-12 headRight">
						{/* <Button className="btn btn-warning" onClick={handleShow}>
              Add Product Image
            </Button> */}
						<Modal show={show} onHide={handleClose}>
							<Modal.Header closeButton>
								<Modal.Title>Add Product Image</Modal.Title>
							</Modal.Header>
							<Modal.Body>
								<Formik initialValues={newInitialValues} validationSchema={productImageSchema} onSubmit={handleSubmit}>
									{({
										values,
										errors,
										touched,
										handleChange,

										handleBlur,
										setFieldValue,
										setFieldTouched,

										setErrors,
									}) => {
										return (
											<FormikForm>
												<div className="form-group has-feedback m-b-25">
													<div>
														<div className="customfile">
															<input
																name="file"
																autoComplete="off"
																id="upload"
																className="form-control"
																type="file"
																multiple
																onChange={(e) => {
																	// console.log("e:", e);
																	fileChangedHandler(
																		e,
																		setFieldTouched,
																		setFieldValue,
																		setErrors,
																		setFile(e.target.files)
																	);
																}}
																accept="image/*"
															/>
														</div>
														{errors.file ? <span className="error">{errors.file}</span> : null}
														<p className="text-info my-2">(Only png file of maximum 5 mb size is supported)</p>
														<p className="text my-2" style={{ fontWeight: 'bold' }}>
															(Image Dimension should be of height 200px and width 200px)
														</p>
													</div>
													<br />

													<div className="row">
														<div className="col-xs-8" />
														<div className="col-xs-4">
															<Modal.Footer>
																<button className="btn btn-warning btn-block w-100" type="submit">
																	<>Save</>
																</button>
															</Modal.Footer>
														</div>
													</div>
												</div>
											</FormikForm>
										);
									}}
								</Formik>
							</Modal.Body>
						</Modal>
					</div>
				</div>
			</section>

			<>
				<section className="tableSection">

					<div className="row">

						<div className="cardBox" style={{ minHeight: '0', padding: '15px 15px 0' }}>
							<div className="d-flex justify-content-between align-items-center mb-3">
								<div className="searchWrapper" style={{ width: '300px' }}>
									<Form.Control
										placeholder="Search by Product Image"
										type="text"
										onChange={handleInputChange}
										value={inputValue}
										style={{ height: '38px' }}
									/>
									{inputValue && (
										<button
											className="suffixIcon"
											onClick={clearSearch}
										>
											<img src={closeIcon} alt="clear" />
										</button>
									)}
								</div>
								<Button
									className="btn"
									style={{
										backgroundColor: '#2C3192',
										color: '#fff',
										border: 'none',
										height: '38px',
										minWidth: '150px',
									}}
									onClick={handleShow}
								>
									Add Product Image
								</Button>
							</div>
							<Table responsive="md">
								<thead>
									<tr className="bg-primary text-white">
										<th className="text-white" style={{ textAlign: 'center', width: '33.33%' }}>
											Product Image
										</th>
										<th className="text-white" style={{ textAlign: 'center', width: '33.33%' }}>
											Image Name
										</th>
										<th className="text-white" style={{ textAlign: 'center', width: '33.33%' }}>
											Action
										</th>
									</tr>
								</thead>

								<tbody>
									{loading && (
										<tr>
											<td colSpan="3" style={{ textAlign: 'center', padding: '20px' }}>
												<Spinner animation="border" variant="primary" />
											</td>
										</tr>
									)}
									{!loading && productImage.length === 0 && (
										<tr>
											<td colSpan="3" style={{ textAlign: 'center', padding: '20px' }}>
												No Records Found
											</td>
										</tr>
									)}
									{!loading && productImage.map((file) => (
										<tr>
											<td
												style={{
													cursor: 'pointer',
													width: '25%',
													textAlign: 'center',
												}}
												onClick={() => {
													setModalShow(true);
													setImg(file.image_url);
												}}
											>
												<img
													style={{ height: '100px', width: '35%' }}
													src={file.image_url}
													alt="alkem_product_image"
												/>
											</td>
											<td>
												<p style={{ textAlign: 'center' }}>
													{file.image_name}
												</p>
											</td>

											<td>
												<div
													style={{
														display: 'flex',
														justifyContent: 'center',
														alignItems: 'center',
														height: '100%',
													}}
												>
													<OverlayTrigger placement="left" overlay={renderTooltip}>
														<span>
															<RiDeleteBin6Line
																style={{
																	fontSize: '25px',
																	cursor: 'pointer',
																	display: 'flex',
																	alignItems: 'center',
																	justifyContent: 'center',
																	width: '100%',
																	height: '100%',
																}}
																className="text-danger"
																onClick={(e) => {
																	handleDelete(file.product_image_id, e);
																}}
															/>
														</span>
													</OverlayTrigger>
												</div>
											</td>
										</tr>
									))}
								</tbody>
							</Table>
						</div>
					</div>
				</section>
				{count > 20 && (
					<Row>
						<Col md={12}>
							<div className="paginationOuter text-right">
								<Pagination
									activePage={activePage}
									itemsCountPerPage={20}
									totalItemsCount={count}
									itemClass="page-item"
									linkClass="page-link"
									activeClass="active"
									prevPageText="Prev"
									nextPageText="Next"
									onChange={handlePageChange}
								/>
							</div>
						</Col>
					</Row>
				)}
				<MyVerticallyCenteredModal show={modalShow} onHide={() => setModalShow(false)} />
			</>
		</div>
	);
}
